<template>
    <div>
        <fieldset>
            <div class="order-header">
                <i class="ion-bookmark"></i>
                <h2>Dodaj numery i wartości zamówień</h2>
            </div>

            <div class="added-order-numbers">
                <div class="order-single-line header-single-line">
                    <h4 id="lp">Lp</h4>
                    <h4 id="order-number">Nr zamówienia</h4>
                    <h4 style="width: 85px" id="order-value">Wartość</h4>
                    <h4 style="width: 85px" id="order-value">Waga</h4>
                </div>

                <div
                    class="order-single-line"
                    v-for="(parcel, index) in orderParts"
                >
                    <h4 id="lp">{{ index + 1 }}</h4>
                    <h4 id="order-number">
                        <input
                            type="text"
                            name="orderStartPoint"
                            v-model="parcel.ordNumber"
                            onfocus="(this.value == 'Wpisz numer zamówienia') && (this.value = '')"
                            onblur="(this.value == '') && (this.value = 'Wpisz numer zamówienia')"
                            class="order-number-add-field"
                            id="orderStartPoint"
                        />
                    </h4>
                    <h4 id="order-value" style="width: 100px">
                        <input
                            type="text"
                            name="orderStartPoint"
                            v-model="parcel.ordValue"
                            value="Wpisz wartość zamówienia"
                            onfocus="(this.value == 'Wpisz wartość zamówienia') && (this.value = '')"
                            onblur="(this.value == '') && (this.value = 'Wpisz wartość zamówienia')"
                            class="order-price-add-field"
                            style="width: 80px"
                            id="orderStartPoint"
                        />
                    </h4>
                    <h4 id="order-weight" style="width: 75px">
                        <input
                            type="text"
                            name="orderStartPoint"
                            v-model="parcel.ordWeight"
                            value="Wpisz wagę przesyłki"
                            onfocus="(this.value == 'Wpisz wagę przesyłki') && (this.value = '')"
                            onblur="(this.value == '') && (this.value = 'Wpisz wagę przesyłki')"
                            class="order-price-add-field"
                            style="width: 65px"
                            id="orderStartPoint"
                        />
                    </h4>
                    <i
                        class="ion-android-cancel clickable"
                        v-on:click="removePart(index)"
                    ></i>
                </div>
                <div style="height: 35px">
                    <i
                        class="ion-android-add-circle color-blue clickable"
                        v-on:click="addPart()"
                    ></i>
                </div>
                <div class="order-single-line header-single-line">
                    <h4 id="lp">SUMA</h4>
                    <h4 style="width: 150px"></h4>
                    <h4 style="'width: 100px" id="order-value">
                        {{ partsValueSum }} zł
                    </h4>
                    <h4 style="width: 100px" id="order-value">
                        {{ partsWeightSum }} kg
                    </h4>
                </div>
            </div>

            <div class="order-info-block">
                <p
                    class="error-message"
                    v-show="orderPartErrorNum"
                    validation-for="name5"
                    style="padding-left: 30px"
                >
                    Prosimy o wpisanie numeru zamówienia.
                </p>
                <p
                    class="error-message"
                    v-show="orderPartErrorValue"
                    validation-for="name6"
                    style="padding-left: 30px"
                >
                    Prosimy o wpisanie wartości zamówienia.
                </p>
                <p
                    class="error-message"
                    v-show="deliveryParcelsError"
                    style="padding-left: 30px"
                >
                    Prosimy o dodanie przynajmniej jednego numeru zamówienia
                    wraz z jego wartością
                </p>
                <p></p>
            </div>
        </fieldset>
    </div>
</template>

<script>
export default {
    name: "parcelsBox",
    props: ["step", "orderParts"],
    data() {
        return {
            deliveryParcelsError: false,
            orderPartsError: false,
            orderPartErrorNum: false,
            orderPartErrorValue: false,
            orderPartDef: {
                ordNumber: "Wpisz numer zamówienia",
                ordValue: "Wpisz wartość zamówienia",
                ordWeight: "Wpisz wagę przesyłki",
            },
            orderPart: {
                ordNumber: "Wpisz numer zamówienia",
                ordValue: "Wpisz wartość zamówienia",
                ordWeight: "Wpisz wagę przesyłki",
            },
        };
    },

    mounted: function () {
        var self = this;
        if (this.orderParts.length == 0) {
            this.orderParts.push({
                ordNumber: "" + this.orderPartDef.ordNumber,
                ordValue: "" + this.orderPartDef.ordValue,
            });
        }
        Event.$on("validateParts", function () {
            var parcelsValid = self.validateParcels();
            self.$emit("parcelsValid", parcelsValid);
        });

        Event.$on("orderStep", function (stepId) {
            if (stepId == 4) {
                //var validParcels = self.validateParcels();
            }
        });
    },

    methods: {
        validateParcels: function () {
            var self = this;

            this.deliveryParcelsError = false;
            this.orderPartErrorNum = false;
            this.orderPartErrorValue = false;

            if (
                this.orderParts.length === 1 &&
                this.orderParts[0].ordNumber ===
                    "" + this.orderPartDef.ordNumber &&
                this.orderParts[0].ordValue === "" + this.orderPartDef.ordValue
            ) {
                this.deliveryParcelsError = true;
            } else if (
                this.orderParts.length === 1 &&
                (_.trim(this.orderParts[0].ordNumber) === "" ||
                    this.orderParts[0].ordNumber ===
                        "" + this.orderPartDef.ordNumber) &&
                this.orderParts[0].ordValue !== "" + this.orderPartDef.ordValue
            ) {
                this.orderPartErrorNum = true;
            } else if (
                this.orderParts.length === 1 &&
                this.orderParts[0].ordNumber !==
                    "" + this.orderPartDef.ordNumber &&
                (_.trim(this.orderParts[0].ordValue) === "" ||
                    this.orderParts[0].ordValue ===
                        "" + this.orderPartDef.ordValue)
            ) {
                this.orderPartErrorValue = true;
            } else if (this.orderParts.length > 1) {
                _.forEach(this.orderParts, function (part) {
                    if (
                        _.trim(part.ordNumber) === "" ||
                        _.trim(part.ordNumber) === self.orderPartDef.ordNumber
                    ) {
                        self.orderPartErrorNum = true;
                    }
                    if (
                        _.trim(part.ordValue) === "" ||
                        _.trim(part.ordValue) === self.orderPartDef.ordValue
                    ) {
                        self.orderPartErrorValue = true;
                    }
                });
            }

            if (
                this.deliveryParcelsError === true ||
                this.orderPartErrorNum === true ||
                this.orderPartErrorValue === true
            ) {
                return false;
            }
            return true;
        },

        validatePart: function (part) {
            this.deliveryParcelsError = false;
            this.orderPartErrorNum = false;
            this.orderPartErrorValue = false;
            if (
                _.trim(part.ordNumber) === "" ||
                _.isEmpty(_.trim(part.ordNumber)) ||
                _.trim(part.ordNumber) === "Wpisz numer zamówienia"
            ) {
                this.orderPartErrorNum = true;
            }
            if (
                _.isEmpty(_.trim(part.ordValue)) ||
                part.ordValue === "Wpisz wartość zamówienia"
            ) {
                this.orderPartErrorValue = true;
            }
            if (
                _.isEmpty(_.trim(part.ordWeight)) ||
                part.ordWeight === "Wpisz wagę przesyłki"
            ) {
                this.orderPartErrorValue = true;
            }

            var oValue = parseFloat(part.ordValue);

            if (_.isNaN(oValue)) {
                this.orderPartErrorValue = true;
            }
            if (
                this.orderPartErrorNum === true ||
                this.orderPartErrorValue === true
            ) {
                return false;
            }
            return true;
        },

        isValidOrderPart: function () {
            this.orderPartErrorNum = false;
            this.orderPartErrorValue = false;
            this.deliveryParcelsError = false;

            if (
                _.trim(this.orderPart.ordNumber) === "" ||
                _.isEmpty(_.trim(this.orderPart.ordNumber)) ||
                _.trim(this.orderPart.ordNumber) === "Wpisz numer zamówienia"
            ) {
                this.orderPartErrorNum = true;
            }
            if (
                _.isEmpty(_.trim(this.orderPart.ordValue)) ||
                this.orderPart.ordValue === "Wpisz wartość zamówienia"
            ) {
                this.orderPartErrorValue = true;
            }

            if (
                _.isEmpty(_.trim(this.orderPart.ordWeight)) ||
                this.orderPart.ordWeight === "Wpisz wagę przesyłki"
            ) {
                this.orderPartErrorValue = true;
            }

            var oValue = parseFloat(this.orderPart.ordValue);

            if (_.isNaN(oValue)) {
                this.orderPartErrorValue = true;
            }
            if (
                this.orderPartErrorNum === true ||
                this.orderPartErrorValue === true
            ) {
                this.deliveryParcelsError = true;
                return false;
            }
            return true;
        },

        clearPart: function () {
            this.orderPart.ordNumber = this.orderPartDef.ordNumber;
            this.orderPart.ordValue = this.orderPartDef.ordValue;
            this.orderPart.ordWeight = this.orderPartDef.ordWeight;
        },

        removePart: function (part) {
            this.$emit("removePart", part);
        },

        addPart: function () {
            var ordValue = 0;
            if (this.orderPartDef.ordValue === "Wpisz wartość zamówienia") {
            } else {
                ordValue = this.orderPartDef.ordValue;
            }
            var ordWeight = 0;
            if (this.orderPartDef.ordWeight === "Wpisz wagę przesyłki") {
            } else {
                ordWeight = this.orderPartDef.ordWeight;
            }
            var newParcel = {
                ordNumber: "" + this.orderPartDef.ordNumber,
                ordValue: "" + ordValue,
                ordWeight: "" + ordWeight,
            };
            this.$emit("addPart", newParcel);
            //setTimeout(this.clearPart, 100);
        },
    },

    filters: {
        toFixed: function (v) {
            return v.toFixed(2);
        },
    },

    computed: {
        partsValueSum: function () {
            var sum = 0;

            if (
                _.isEmpty(this.orderParts) ||
                this.orderParts[0].ordValue === ""
            ) {
                sum = 0;
            }
            var self = this;
            _.forEach(this.orderParts, function (item) {
                var itemValue = parseFloat(item.ordValue);
                if (parseFloat(item.ordValue)) {
                    sum += parseFloat(item.ordValue);
                } else {
                    sum += 0;
                }
            });
            if (_.isNaN(sum)) {
                sum = 0;
            }
            Event.$emit("changePartValue", sum);
            return sum.toFixed(2);
        },
        partsWeightSum: function () {
            var sum = 0;

            if (
                _.isEmpty(this.orderParts) ||
                this.orderParts[0].ordWeight === ""
            ) {
                sum = 0;
            }
            var self = this;
            _.forEach(this.orderParts, function (item) {
                var itemValue = parseFloat(item.ordWeight);
                if (parseFloat(item.ordWeight)) {
                    sum += parseFloat(item.ordWeight);
                } else {
                    sum += 0;
                }
            });
            if (_.isNaN(sum)) {
                sum = 0;
            }
            Event.$emit("changePartWeight", sum);
            return sum.toFixed(2);
        },
    },
};
</script>
<style scoped>
.desktop .added-order-numbers i.ion-android-cancel {
    position: relative;
    top: 3px;
    right: 0;
}
.desktop .added-order-numbers i.ion-android-add-circle {
    position: relative;
    margin-top: 10px;
    right: 0;
    top: 0;
}
</style>



// WEBPACK FOOTER //
// ParcelsBox.vue?857c0fca